<template>

    <b-card>

        <b-row class="mb-2">

            <b-col sm="6" md="4" class="my-1">

                <div class="d-flex align-items-center justify-content-between">

                    <date-picker
                            v-model="start_date"
                            placeholder="Start Date"
                            class="f-1"
                    >
                    </date-picker> &nbsp;to&nbsp;
                    <date-picker
                            v-model="end_date"
                            placeholder="End Date"
                            class="f-1"
                    >
                    </date-picker>
                </div>
            </b-col>
            <b-col sm="6" md="4" class="my-1" v-if=" scopedUserId == null ">

                <transition mode="out-in" name="slide-fade">

                    <user-role-search-dropdown v-if=" current_filter_type == 'provider' " type="provider" v-model=" user_id "></user-role-search-dropdown>
                    <user-role-search-dropdown v-if=" current_filter_type == 'claimant' " type="claimant" v-model=" user_id "></user-role-search-dropdown>
                </transition>
            </b-col>
            <b-col sm="12" class="d-flex align-items-center justify-content-end my-1">

                <b-button variant="primary" @click=" changeFilterType() " class="mr-2">{{ filterTypeButtonText }}</b-button>
                <b-button @click=" loadTable() " variant="info" :disabled=" loading " class="mr-2">Generate Report</b-button>
                <b-btn variant="success" @click=" exportXls() " :disabled=" loading "><i class="fa fa-file-excel-o"></i> Export to Excel</b-btn>
            </b-col>
        </b-row>

        <div class="table-responsive">

            <b-table bordered striped hover show-empty
                :items=" items "
                :fields=" fields "
                :current-page=" currentPage "
                :per-page=" 0 "
                :sort-by.sync=" sortBy "
                :sort-desc.sync=" sortDesc "
                :busy=" loading "
            >
                <template v-slot:cell(auditable_name)="row">

                    {{ ( row.item.parent ? row.item.parent.name : '' ) }}
                </template>
                <template v-slot:cell(changer)="row">

                    {{ ( row.item.user ? row.item.user.name : '' ) }}
                </template>
                <template v-slot:cell(actions)="row">

                    <b-btn size="sm" @click=" viewItem( row.item ) ">View</b-btn>
                </template>
            </b-table>
        </div>

        <b-row>

            <b-col lg="6" >

                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
            </b-col>
            <b-col lg="6" class="text-right">

                {{ paginationText }}
            </b-col>
        </b-row>

        <b-modal id="auditModal" title="Selected Audit" v-model="auditModal" size="lg">
            <b-container fluid>
                <b-row>
                    <h4>User Details</h4>
                    <table class="table table-striped">
                        <tr>
                            <th>Username</th>
                            <td>{{ selectedItem.user ? selectedItem.user.username : '' }}</td>
                        </tr>
                        <tr>
                            <th>IP Address</th>
                            <td>{{ selectedItem.ip_address }}</td>
                        </tr>
                        <tr>
                            <th>Date Modified</th>
                            <td><utc-time :time="selectedItem.created_at" :role="this.role" /></td>
                        </tr>
                        <tr>
                            <th>User Agent</th>
                            <td>{{ selectedItem.user_agent }}</td>
                        </tr>
                    </table>
                    <h4>Changed Instance</h4>
                    <table class="table table-striped">
                        <th>{{ selectedItem.auditable_type }}</th>
                        <td>{{ selectedItem.auditable_id }}</td>
                    </table>
                    <h4>Changed Values</h4>
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th>Attribute</th>
                            <th>Old Value</th>
                            <th>New Value</th>
                        </tr>
                        </thead>
                        <tr v-for="(value, key) in selectedItem.new_values" :key="key">
                            <th>{{ key }}</th>
                            <td style="max-width: 125px; overflow: hidden;">{{ selectedItem.old_values[key] ? selectedItem.old_values[key] : '' }}</td>
                            <td style="max-width: 125px; overflow: hidden;">{{ selectedItem.new_values[key] ? selectedItem.new_values[key] : '' }}</td>
                        </tr>
                    </table>
               </b-row>
            </b-container>
            <div slot="modal-footer">
               <b-btn variant="default" @click="auditModal=false">Close</b-btn>
            </div>
        </b-modal>
    </b-card>
</template>

<script>

    import FormatsDates from "../../mixins/FormatsDates";
    import PaginatedTable from "../../mixins/PaginatedTable";
    import UsesRole from "../../mixins/UsesRole";

    export default {

        mixins: [ FormatsDates, PaginatedTable, UsesRole ],

        props: {

            scopedUserId: {

                type: Number,
                default: null,
                required: false
            }
        },

        data() {

            return {

                start_date   : moment().startOf( 'isoweek' ).format( 'MM/DD/YYYY' ),
                end_date     : moment().startOf( 'isoweek' ).add( 6, 'days' ).format( 'MM/DD/YYYY' ),
                user_id      : null,

                current_filter_type : 'claimant',

                selectedItem : {},
                auditModal   : false,

                fields: [
                    {
                        key: 'created_at',
                        label: 'Date Modified',
                        sortable: true,
                        formatter: d => this.formatDateTimeFromUTC(d),
                    },
                    {
                        key: 'changer',
                        label: 'Changed By',
                        sortable: true,
                    },
                    {
                        key: 'auditable_type',
                        label: 'Auditable Type',
                        sortable: true,
                    },
                    {
                        key: 'auditable_id',
                        label: 'Auditable ID',
                        sortable: true,
                    },
                    {
                        key: 'auditable_name',
                        label: 'User Effected',
                        sortable: true,
                    },
                    {
                        key: 'event',
                        label: 'Action',
                        sortable: true,
                    },
                    {
                        key: 'ip_address',
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print'
                    }
                ],
            }
        },

        mounted() {

        },

        computed: {

            baseUrl(){ return `/${this.controller}/reports/audit-log`; },
            filterTypeButtonText(){ return this.current_filter_type == 'claimant' ? 'Change Search to Providers' : 'Change Search to Claimants'; },
            userId(){ return this.scopedUserId || this.user_id },
            appliedFilters() { return `?start=${this.start_date}&end=${this.end_date}&scopedUser=${this.userId}&json=1`; },
        },

        methods: {

            changeFilterType(){

                this.user_id = null;
                switch( this.current_filter_type ){

                    case 'claimant':

                        this.current_filter_type = 'provider';
                        break;
                    case 'provider':

                        this.current_filter_type = 'claimant';
                        break;
                    default:
                        break;
                }
            },
            viewItem( item) {

                this.selectedItem = item;
                this.auditModal = true;
            }
        }
    }
</script>